import React from 'react';
import { useTranslation } from 'react-i18next';
import { Zap, Shield, BarChart, Users, Lock, Clock } from 'lucide-react';

export default function LandingFeatures() {
  const { t } = useTranslation();
  const features = [
    { icon: Zap, title: t('landing.features.aiGeneration.title'), description: t('landing.features.aiGeneration.description') },
    { icon: Shield, title: t('landing.features.vendorMatching.title'), description: t('landing.features.vendorMatching.description') },
    { icon: BarChart, title: t('landing.features.scoring.title'), description: t('landing.features.scoring.description') },
    { icon: Users, title: t('landing.features.collaboration.title'), description: t('landing.features.collaboration.description') },
    { icon: Lock, title: t('landing.features.security.title'), description: t('landing.features.security.description') },
    { icon: Clock, title: t('landing.features.analytics.title'), description: t('landing.features.analytics.description') },
  ];
  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">{t('landing.features.title')}</h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">{t('landing.features.subtitle')}</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div key={feature.title} className="group bg-slate-50 rounded-xl p-8 hover:bg-white hover:shadow-xl border border-slate-200 transition-all duration-300">
              <div className="w-14 h-14 bg-primary rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <feature.icon className="w-7 h-7 text-primary-foreground" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{feature.title}</h3>
              <p className="text-slate-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
